export const LOGIN_ANNOUNCEMENTS_PENDING_KEY = 'kab.loginAnnouncements.pending';

function getSessionStorage(storage) {
  if (storage) {
    return storage;
  }

  if (typeof window === 'undefined') {
    return null;
  }

  return window.sessionStorage;
}

export function markLoginAnnouncementsPending(storage) {
  const targetStorage = getSessionStorage(storage);
  if (!targetStorage) {
    return;
  }

  try {
    targetStorage.setItem(LOGIN_ANNOUNCEMENTS_PENDING_KEY, 'true');
  } catch (error) {
    console.warn('No se pudo guardar el estado de anuncios de login:', error);
  }
}

export function shouldShowLoginAnnouncements(storage) {
  const targetStorage = getSessionStorage(storage);
  if (!targetStorage) {
    return false;
  }

  try {
    return targetStorage.getItem(LOGIN_ANNOUNCEMENTS_PENDING_KEY) === 'true';
  } catch (error) {
    console.warn('No se pudo leer el estado de anuncios de login:', error);
    return false;
  }
}

export function clearLoginAnnouncementsPending(storage) {
  const targetStorage = getSessionStorage(storage);
  if (!targetStorage) {
    return;
  }

  try {
    targetStorage.removeItem(LOGIN_ANNOUNCEMENTS_PENDING_KEY);
  } catch (error) {
    console.warn('No se pudo limpiar el estado de anuncios de login:', error);
  }
}
